import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import BlueskyIcon from "@ui/components/icon/social/BlueskyIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  title: string;
  onPopoverClose: () => void;
}

/**
 * Bluesky share button component for the share popover
 */
const ShareButtonsBlueskyPopover: FunctionComponent<Props> = ({
  url,
  title,
  onPopoverClose,
}) => {
  const analytics = useAnalytics();

  const handleBlueskyShare = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "bluesky" },
    });

    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const blueskyUrl = `https://bsky.app/intent/compose?text=${encodedTitle}%20${encodedUrl}`;
    window.open(
      blueskyUrl,
      "share_bluesky",
      "width=658, height=354, scrollbars=no",
    );
    onPopoverClose();
  };

  return (
    <button
      onClick={handleBlueskyShare}
      className={styles.shareOption}
      aria-label="Share on Bluesky"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <BlueskyIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>Bluesky</span>
    </button>
  );
};

export default ShareButtonsBlueskyPopover;
